<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="tarjeta.caja_fecha"
              label="Fecha"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="tarjeta.turno"
              label="Turno"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" v-if="!isNewRecord">
            <v-text-field
              v-model="tarjeta.usuario_iniciales"
              label="Usuario"
              readonly
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-text-field
              v-model.number="tarjeta.registro"
              label="Registro"
              type="number"
              required
            ></v-text-field>
          </v-col> -->
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="tarjeta.maestro_tarjetas_id"
              :items="maestroTarjetas"
              item-title="nombre"
              item-value="id"
              label="Tarjeta"
              :onchange="calcComision()"
              required
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="tarjeta.importe"
              label="Importe"
              type="number"
              step="0.01"
              :onblur="calcComision()"
              required
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-text-field
              v-model.number="tarjeta.importe_comision"
              label="Importe Comisión"
              type="number"
              step="0.01"
              required
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="tarjeta.importe_neto"
              label="Importe Neto"
              type="number"
              step="0.01"
              required
              readonly
            ></v-text-field>
          </v-col> -->
          <v-col cols="12" md="12">
            <v-text-field
              v-model="tarjeta.detalle"
              label="Detalle"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ tarjeta.id ? 'Actualizar' : 'Crear' }} Tarjeta
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
      <BaseModal
        v-model="showModal"
        :title="modalConfig.title"
        :message="modalConfig.message"
        :type="modalConfig.type"
        :button-text="modalConfig.buttonText"
      />
    </v-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { useTarjetasStore } from '@/stores/tarjetasStore'
import { useMaestroTarjetasStore } from '@/stores/maestroTarjetasStore'
import { getUser } from '@/utils/tokenStorage'
import { focusFirstInput, formatDate, userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
import BaseModal from '../common/BaseModal.vue'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})

// Estado del modal
const showModal = ref(false)
const modalConfig = reactive({
  title: '',
  message: '',
  type: 'info',
  buttonText: 'Aceptar'
})

const emit = defineEmits(['saved'])

const tarjetasStore = useTarjetasStore()
const maestroTarjetasStore = useMaestroTarjetasStore()
const userIsRecepcionValue = userIsRecepcion()
const loading = ref(false)
const maestroTarjetas = ref([])

const tarjeta = reactive({
  id: null,
  caja_fecha: null,
  caja_id: null,
  usuario_id: null,
  turno: '',
  hotel: '',
  registro: null,
  detalle: '',
  maestro_tarjetas_id: null,
  importe: null,
  porcentaje_comision: null,
  importe_comision: null,
  importe_neto: null,
  usuario_iniciales: ''
})

// Métodos para mostrar modales
const showError = (message) => {
  modalConfig.title = 'Error'
  modalConfig.message = message
  modalConfig.type = 'error'
  modalConfig.buttonText = 'Entendido'
  showModal.value = true
}

const calcComision = () => {
  if (tarjeta.maestro_tarjetas_id) {
    const maestroTarjeta = maestroTarjetas.value.find(
      (t) => t.id == tarjeta.maestro_tarjetas_id
    )
    if (maestroTarjeta !== undefined) {
      tarjeta.porcentaje_comision = maestroTarjeta.porcentaje_comision
      tarjeta.importe_comision =
        (tarjeta.importe * tarjeta.porcentaje_comision) / 100
      tarjeta.importe_neto = tarjeta.importe - tarjeta.importe_comision
      console.log('calc', maestroTarjeta.porcentaje_comision)
      console.log('calc', tarjeta.importe_comision)
      console.log('calc', tarjeta.importe_neto)
    }
  }
}

const isNewRecord = computed(() => !tarjeta.id)

onMounted(async () => {
  const userInfo = getUser()
  tarjeta.usuario_id = userInfo.id
  tarjeta.hotel = userInfo.hotel
  tarjeta.turno = userInfo.turno

  await loadMaestroTarjetas()
  const data = await tarjetasStore.getTarjeta(props.id)

  if (props.id) {
    Object.assign(tarjeta, data)
    loading.value = true
    try {
      console.log(data)
      tarjeta.usuario_iniciales = data.usuario_iniciales || ''
      tarjeta.caja_fecha = formatDate(data.caja_fecha) || ''
      tarjeta.caja_id = data.caja_id || null
      console.log(tarjeta)
    } catch (error) {
      console.error('Error al cargar la tarjeta:', error)
    } finally {
      loading.value = false
    }
  } else {
    tarjeta.registro = data.registro
  }
  // Add focus to first enabled input after form is loaded
  focusFirstInput()
})

async function loadMaestroTarjetas() {
  try {
    maestroTarjetas.value = await maestroTarjetasStore.fetchMaestroTarjetas({})
  } catch (error) {
    console.error('Error al cargar maestro tarjetas:', error)
  }
}

const submitForm = async () => {
  // console.log('maestroTarjetas', maestroTarjetas)
  // console.log('TARJETA', tarjeta.maestro_tarjetas_id)
  // console.log('TARJETA', parseFloat(tarjeta.importe))
  // si maestro_tarjetas_id es null, no se puede crear la tarjeta, mostrar modal de error
  if (tarjeta.maestro_tarjetas_id == null) {
    showError('No has seleccionado una tarjeta')
    return
  }
  // si importe es 0, no se puede crear la tarjeta, mostrar modal de error
  if (tarjeta.importe == null || parseFloat(tarjeta.importe) == 0) {
    showError('El importe debe ser mayor a 0')
    document.getElementById('importe').focus()
    return
  }
  loading.value = true
  try {
    if (tarjeta.id) {
      await tarjetasStore.updateTarjeta(tarjeta)
    } else {
      await tarjetasStore.createTarjeta({ ...tarjeta })
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar la tarjeta:', error)
  } finally {
    loading.value = false
  }
}

defineExpose({
  tarjeta,
  loading,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})
</script>
